import clsx from "clsx";
import React from "react";
import { withStyles } from "@mui/styles";
import { Button as MuiButton } from "@mui/material";

import { styles } from "./styles";

const Button = ({ classes, children, disabled, endIcon, label, onClick, selected, startIcon, type = "primary" }) => (
  <MuiButton
    className={clsx(classes[type], selected && classes.selected, classes.general)}
    disabled={disabled}
    endIcon={endIcon}
    onClick={onClick}
    startIcon={startIcon}
  >
    {label || children}
  </MuiButton>
);

export default withStyles(styles)(Button);
